import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box} from '@material-ui/core';
import {Table, TableBody, TableCell, LinearProgress, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
// import {Edit, Autorenew, AddTask} from '@mui/icons-material';
// import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DeleteAlert from '../components/DeleteAlert'; 
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className="btmbdrgry"><h3>{children}</h3></div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [pageLoading, setPageLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [rows, setRows] = React.useState([]);   
  
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setPageLoading(false);
    if(open && props.dataObj && props.dataObj.autoId && userObj && userObj.loginId){	
      getApiData();    
    }else{
      setRows([]);    
    }
	}, [open,props.dataObj,userObj]);

	async function getApiData(){
    setPageLoading(false); 
      let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
      let endpoints1 = env.API_URL+"/exams/read/exam-templates?sortby=templateTitle";
      let endpoints2 = env.API_URL+"/exams/read/topic-content-hidden?contentId="+props.dataObj.autoId;
      const axiosrequest1 = axios.get(endpoints1,axiosHeader);
      const axiosrequest2 = axios.get(endpoints2,axiosHeader);    
      await axios.all([axiosrequest1, axiosrequest2]).then(axios.spread(function(res1, res2) {
        setPageLoading(false);
        if(res1.data && res1.data.responseTxt==="success"){
          setRows(res1.data?.obj?.list);
          if(res2.data && res2.data.responseTxt==="success"){
            ///alert(JSON.stringify(res1.data.list));
            for(let i=0; i<res1.data?.obj?.list.length; i++){  
                if(res2.data?.obj?.list.includes(res1.data?.obj?.list[i].autoId,0)){                
                  document.getElementById('ct'+i).checked=true;
                }else{
                  document.getElementById('ct'+i).checked=false;
                }
            }
          }
        }      
      }));
  
	}

  function handleCourseTemplate(chk,obj){
    if(chk===true){
      addCourseTemplate(obj);
    }else{
      deleteCourseTemplate(obj);
    }
  }

  function addCourseTemplate(obj){    
      if(obj && userObj.token){
        let axiosHeader = {
            headers: {
              'Content-Type': 'multipart/mixed',
              'loginId': userObj.loginId,
              'token': userObj.token,
              'device': 'web'
          }
        }; 
  
        const data = new FormData();
        data.append('templateId', obj.autoId);
        data.append('templateTitle', obj.templateTitle);
        data.append('contentId', props.dataObj.autoId);
        
        axios.post(env.API_URL+'/exams/create/topic-content-hidden', data, axiosHeader)
          .then((response) => {
            if(response.data && response.data.responseTxt==="invalidToken"){ 
              Cookies.remove('isadminloggedin');
              window.location.href='login';
            }else if(response.data && response.data.responseTxt==="success"){
              ///setRows(response.data.list);
              setSeverityAlert("success");
              setShowAlert(true);
              setAlertMessage("Content has been hidden.");
            }else{
              setSeverityAlert("error");
              setShowAlert(true);
              setAlertMessage("Something wrong happened for some reason.");			
              return false;
            }	
        })
      }				
  }

  function deleteCourseTemplate(obj){    
    if(obj && userObj.token){
      let axiosHeader = {
          headers: {
            'Content-Type': 'multipart/mixed',
            'loginId': userObj.loginId,
            'token': userObj.token,
            'device': 'web'
        }
      }; 

      const data = new FormData();
      data.append('templateId', obj.autoId);
      data.append('contentId', props.dataObj.autoId);
      
      axios.post(env.API_URL+'/exams/delete/topic-content-hidden', data, axiosHeader)
        .then((response) => {
          if(response.data && response.data.responseTxt==="invalidToken"){ 
            Cookies.remove('isadminloggedin');
            window.location.href='login';
          }else if(response.data && response.data.responseTxt==="success"){
            ///setRows(response.data.list);
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Course template has been removed.");
          }else{
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Something wrong happened for some reason.");			
            return false;
          }	
      })
    }				
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>Hide <span style={{color:'blue'}}>{props.dataObj.contentName}</span> in Course Templates</DialogTitle>
          <DialogContent >
          {pageLoading?<LinearProgress />:null}
          <Box mt={2}>
          <Grid container  >            
            <Grid item md={12} xs={12} >
            {(rows && rows.length>0)?  
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead> 
                    <TableRow>
                      <TableCell style={{whiteSpace: 'nowrap'}} ></TableCell>
                      <TableCell style={{whiteSpace: 'nowrap'}} ><b>Title</b></TableCell>
                      <TableCell style={{whiteSpace: 'nowrap'}} ><b>ID</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row,i) => (
                      <TableRow
                        key={row.autoId}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      > 
                        <TableCell style={{whiteSpace: 'nowrap'}} ><input id={"ct"+i} onClick={(event)=>{handleCourseTemplate(event.target.checked,row)}} type='checkbox' /></TableCell>
                        <TableCell style={{whiteSpace: 'nowrap'}} >{row.templateTitle}</TableCell>
                        <TableCell style={{whiteSpace: 'nowrap'}} >{row.autoId}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            :null}

            </Grid>
          </Grid>  
        </Box>

        {(!rows || rows.length<1)?<div className='nrfbox' >No Row found</div>:null}


       </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>



    </>
  );

});

export default CustomizedDialogs;